import { Dependente } from './../shared/model/Dependente.model';
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class DependenteService {

  urlBaseApi: string;
  urlBaseDependetesApi: string;
  valueFilter: string;
  constructor(private http: HttpClient) {
    this.urlBaseDependetesApi = `${environment.mouraAmmServerURL}/dependente`;
    this.urlBaseApi = `${environment.mouraAmmServerURL}/guia`;
  }

  listarDependentes(filtroNome: string): Observable<any> {
    let params = new HttpParams();
    if (filtroNome) {
      params = params.set('nome', filtroNome);
    }
    return this.http.get(`${this.urlBaseDependetesApi}`, { params });
  }

  salvarDependente(dependente: Dependente): Observable<any> {
    return this.http.post(`${this.urlBaseDependetesApi}`, dependente);
  }

  deletarDependente(dependenteId: number): Observable<any> {
    return this.http.delete(`${this.urlBaseDependetesApi}/${dependenteId}/`);
  }

  buscarColaboradorPorMatricula(matricula: string): Observable<any> {
    return this.http.get(`${this.urlBaseApi}/consultar-dependentes/${matricula}`);
  }
}
